import { store } from "../store/index";
import {
	updateTables,
	updateReservations,
	updateOccupiedDays,
	updateAreas
} from "../actions/store/app-actions";
import { getTables, Table } from "./tables";
import {
	Reservation,
	getReservations,
	getReservationsByDay
} from "./reservations";
import { getOccupiedDayByDate } from "./occupied-days";
import { getAreas, Area } from "./areas";
import { setActiveArea } from "../actions/store/overview-actions";
import { getInquiriesAndUpdateStore } from "../actions/inquiry-actions";
import { getMessageSignatures } from "./settings";
import { updateSignatures, updateMeals } from "../actions/store/settings-actions";
import { sendClientData, ClientData } from "./auth";
import { getMeals } from './meals';
import { requestNotificationToken } from '../integration/capabilities';

type Data = [[Area], Table[]];

let currentSelectedDate: Date;

export const updateDateRelatedData = async () => {
	const date = store.getState().date;

	const day = await getOccupiedDayByDate(date);
	store.dispatch(updateOccupiedDays([day]));

	const reservations = await getReservationsByDay(date);
	store.dispatch(updateReservations(reservations));
};

export const updateInquiryList = async () => {
	const { startDate, endDate } = store.getState().inquiryListDateRange;
	await getInquiriesAndUpdateStore(startDate, endDate);
};

export const updateMessageSignatures = async () => {
	try {
		const res = await getMessageSignatures();
		store.dispatch(updateSignatures(res));
	} catch (e) {}
};

export const updateMealsInStore = async () => {
	try {
		const res = await getMeals();
		store.dispatch(updateMeals(res));
	} catch (e) {}
};

export const handleSelectedDateChange = async () => {
	const update = async () => {
		try {
			await updateDateRelatedData();
		} catch (e) {}
	};

	store.subscribe(() => {
		let previousSelectedDate = currentSelectedDate;
		currentSelectedDate = store.getState().date;

		if (
			!previousSelectedDate ||
			(currentSelectedDate &&
				previousSelectedDate &&
				currentSelectedDate.getTime() !==
					previousSelectedDate.getTime())
		) {
			update();
		}
	});

	await update();
};

export const loadInitialData = async () => {
	const capabilities = store.getState().capabilities;
	const notificationToken = await requestNotificationToken();

	const clientData: ClientData = {
		type: capabilities.type,
		notificationToken,
	};

	await sendClientData(clientData);

	const [areaRes, tableRes]: Data = await Promise.all([
		getAreas(),
		getTables()
	]);

	await updateInquiryList();
	await updateMessageSignatures();
	await updateMealsInStore();

	if (store.getState().overviewActiveAreaId === null && areaRes.length > 0) {
		store.dispatch(setActiveArea(areaRes[0].id));
	}

	store.dispatch(updateAreas(areaRes));
	store.dispatch(updateTables(tableRes));

	handleSelectedDateChange();
};
